var $2d1ba151d54f8eea$exports = {};
$2d1ba151d54f8eea$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};


export {$2d1ba151d54f8eea$exports as default};
//# sourceMappingURL=es-ES.mjs.map
